import Request, { SimpleResponse } from './Request';

export interface IPlan {
    id: number;
    groupId: number;
    groupName: string;
    groupCode: string;
    groupParentId: number;

    channels: IChannel[];
    children: IPlan[];
}

export interface IChannel {
    channelId: number;
    channelName: string;
    channelOrder: number;
    channelTypeId: number;
    channelTypeName: string;
    channelTypeSlug: string;
    id: number;
    currentDate: Date;
    previousActual: number;
    previousDate: Date;
    planBusinessPlan: number;
    planFRE: number;
    planSRE: number;
}

class Plan {
    static GetAll = (year: number, month: number): IPlan[] => { 
        return Request.DoGet(`plan/all/${year}/${month}`) as unknown as IPlan[]; 
    };

    static Get = (group: number, year: number, month: number): IPlan => { 
        return Request.DoGet(`plan/${group}/${year}/${month}`) as unknown as IPlan; 
    };

    static Update = (id: number, data: IPlan): SimpleResponse => { 
        return Request.DoPut(`plan/${id}`, data) as unknown as SimpleResponse; 
    };

    static Create = (year: number, month: number, data: IPlan): SimpleResponse => { 
        return Request.DoPost(`plan/${year}/${month}`, data) as unknown as SimpleResponse; 
    };
}

export default Plan;